import { selectChangeMessageForHtmlString } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForHtmlString';
import { type EditAsideTitle, RequiredType } from '@nodeTypeConfig/configTypes';

export const titleComponent: EditAsideTitle = {
  component: 'title',
  reactComponent: 'AsideTitle',
  property: 'title',
  label: 'Titel',
  asideChangeMessageSelector: selectChangeMessageForHtmlString,
  required: RequiredType.ERROR,
};

export const titleAsDescriptionComponent: EditAsideTitle = {
  ...titleComponent,
  property: 'description',
  label: 'Omschrijving',
};
